import { c as _c } from "react/compiler-runtime";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { DateTimePicker } from "@/components/ui/shadcn-io/datetime-picker";
import { Matcher } from "react-day-picker";
import { Control, FieldPath, FieldValues, useWatch } from "react-hook-form";
type Props<TFieldValues extends FieldValues, TFieldName extends FieldPath<TFieldValues>> = {
  label?: string;
  control: Control<TFieldValues, TFieldName>;
  name: TFieldName;
  disabledMatcher?: Matcher;
};
export function DateInput(t0) {
  const $ = _c(15);
  let control;
  let name;
  let props;
  if ($[0] !== t0) {
    ({
      control,
      name,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = control;
    $[2] = name;
    $[3] = props;
  } else {
    control = $[1];
    name = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== control || $[5] !== name) {
    t1 = {
      control,
      name
    };
    $[4] = control;
    $[5] = name;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const outwardDate = useWatch(t1);
  let t2;
  if ($[7] !== outwardDate || $[8] !== props.disabledMatcher || $[9] !== props.label) {
    t2 = t3 => {
      const {
        field
      } = t3;
      return <FormItem className="relative flex flex-col"><FormLabel className="leading-5">{props.label}</FormLabel><FormControl><DateTimePicker {...field} onChange={e => {
            if (e && outwardDate) {
              e.setHours(outwardDate.getHours(), outwardDate.getMinutes(), outwardDate.getSeconds(), outwardDate.getMilliseconds());
            }
            field.onChange(e);
          }} onlyDate={true} disabled={props.disabledMatcher} triggerClassName="h-auto rounded-none bg-white p-4 md:text-lg focus:border-matchbus w-full justify-start text-secondary" className="text-secondary" /></FormControl><FormMessage /></FormItem>;
    };
    $[7] = outwardDate;
    $[8] = props.disabledMatcher;
    $[9] = props.label;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== control || $[12] !== name || $[13] !== t2) {
    t3 = <FormField control={control} name={name} render={t2} />;
    $[11] = control;
    $[12] = name;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}